import authRoute from "./Auth/index.route";
import theme04Route from "./Theme04/index.route";
// import theme04Route from "./Theme04/index.page";

import theme02Route from "./Theme02/index.route";
import Theme01 from "./Theme01/index.route";
import Theme03 from "./Theme03/index.route";
import FamilyTree from "./FamilyTree/index.route";
import ScreenShot from "./ScreenShot/index.route";

export default function route(t) {
  return [
    ...authRoute(t),
    ...theme04Route(),
    ...theme02Route(),
    ...Theme01(),
    ...Theme03(),
    ...FamilyTree(),
    ...ScreenShot(),
  ];
}
